"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var react_color_1 = require("react-color");
var CardRowColorPickerEditor_1 = require("../../../../../../shared/components/editors/CardRowColorPickerEditor");
var CfgUsrPlayerTagEditor = /** @class */ (function (_super) {
    __extends(CfgUsrPlayerTagEditor, _super);
    function CfgUsrPlayerTagEditor(props) {
        return _super.call(this, props) || this;
    }
    CfgUsrPlayerTagEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    code: _item.code,
                    color: _item.color,
                    is_deprecated: _item.is_deprecated,
                    tag_type_code: _item.tag_type_code,
                    tag_type_title: _item.tag_type_title,
                    show_picker: false
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование метки"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                code: "",
                color: "#FF0000",
                is_deprecated: false,
                tag_type_code: 0,
                tag_type_title: "",
                show_picker: false
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание метки"]);
            });
        }
        this.doReSetRules();
    };
    CfgUsrPlayerTagEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            code_rules: { isError: false },
            color_rules: { isError: false },
            tag_type_rules: { isError: false },
        });
    };
    CfgUsrPlayerTagEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                code: this.state.code,
                title: this.state.title,
                is_deprecated: this.state.is_deprecated,
                color: this.state.color
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Метка пользователя изменена!");
            });
        }
    };
    CfgUsrPlayerTagEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        if ((!this.state.code) || (this.state.code.length === 0)) {
            this.setState({ code_rules: { isError: true, errorMessage: "Поле [код] не заполнено!" } });
            return false;
        }
        if ((!this.state.color) || (this.state.color.length !== 7)) {
            this.setState({ color_rules: { isError: true, errorMessage: "Поле [цвет] имеет некорректное значение!" } });
            return false;
        }
        if ((this.state.tag_type_code === 0) || (this.state.tag_type_title.length === 0)) {
            this.setState({ tag_type_rules: { isError: true, errorMessage: "Поле [тип тэга] имеет некорректное значение!" } });
            return false;
        }
        return true;
    };
    CfgUsrPlayerTagEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                code: this.state.code,
                title: this.state.title,
                is_deprecated: this.state.is_deprecated,
                color: this.state.color,
                tag_type: this.state.tag_type_code
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Метка пользователя добавлена!");
            });
        }
    };
    CfgUsrPlayerTagEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    CfgUsrPlayerTagEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить метку пользователя";
        }
        else {
            return "Изменить метку пользователя";
        }
    };
    CfgUsrPlayerTagEditor.prototype.handleClose = function () {
        this.setState({ show_picker: false });
    };
    CfgUsrPlayerTagEditor.prototype.getColorPicker = function () {
        if (this.state.show_picker) {
            return (React.createElement("div", { style: { position: 'absolute', zIndex: 2, } },
                React.createElement("div", { style: {
                        position: 'fixed',
                        top: '0px',
                        right: '0px',
                        bottom: '0px',
                        left: '0px',
                    }, onClick: this.handleClose.bind(this) }),
                React.createElement(react_color_1.ChromePicker, null)));
        }
    };
    CfgUsrPlayerTagEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 450 },
            this.getColorPicker(),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название метки:", placeholder: "Введите название метки" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Код метки:", placeholder: "Введите код метки" }, value: this.state.code, onValueChanged: function (newVal) {
                    _this.setState({
                        code: newVal,
                        code_rules: { isError: false }
                    });
                }, required: true, rules: this.state.code_rules }),
            React.createElement(CardRowColorPickerEditor_1.default, { texts: { caption: "Цвет метки:", placeholder: "Выберите цвет метки", buttonHint: "Выберите цвет" }, color: this.state.color, onColorChanged: function (newVal) {
                    _this.setState({
                        color: newVal,
                        color_rules: { isError: false }
                    });
                }, required: true, rules: this.state.color_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип метки:", placeholder: "Выберите тип метки" }, value: { key: this.state.tag_type_code, value: this.state.tag_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        tag_type_code: newVal.key,
                        tag_type_title: newVal.value,
                        tag_type_rules: { isError: false }
                    });
                }, items: this.props.availTagTypes, disabled: this.props.record != null, required: true, rules: this.state.tag_type_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Метка устарела", value: this.state.is_deprecated, onChecked: function (checked) {
                    _this.setState({
                        is_deprecated: checked
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return CfgUsrPlayerTagEditor;
}(React.Component));
exports.default = CfgUsrPlayerTagEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_player_tags/ui/component/CfgUsrPlayerTagEditor.tsx
// module id = 2167
// module chunks = 0